import React from 'react';
import Icon from './Icon';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder }) => (
  <div style={{ position: 'relative' }}>
    <span style={{
      position: 'absolute',
      left: 12,
      top: '50%',
      transform: 'translateY(-50%)',
      color: 'var(--text2)',
      pointerEvents: 'none',
      zIndex: 2,
    }}>
      <Icon name="search" size={15} />
    </span>
    <input
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder || 'Поиск...'}
      style={{ paddingLeft: 36 }}
    />
  </div>
);

export default SearchBar;
